var exports = {
  "kL": "xa15a2ab7--6c8b47--container",
  "DD": "xa15a2ab7--6c8b47--title",
  "Qq": "xa15a2ab7--6c8b47--text",
};

module.exports = exports;
